// src/pages/userProfile/PoleceniaTab.js
import React, { useEffect, useState } from 'react';
import { Button, Form, Input, List, message, Modal, Spin, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useFirebase } from '../../FirebaseContext';
import { addReferralForUser, fetchReferralsForUser } from '../../services/referralsService';

// userData — данные редактируемого пользователя (вкл. uid/firstName/lastName/phoneNumber)
const PoleceniaTab = ({ userId, userData }) => {
  const { currentFirebase } = useFirebase();
  const firestore = currentFirebase.firestore;

  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const load = async () => {
    setLoading(true);
    try {
      setReferrals(await fetchReferralsForUser({ firestore, uid: userId }));
    } catch (e) {
      message.error('Błąd ładowania poleceń');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (userId) load(); /* eslint-disable-next-line */ }, [userId]);

  const handleAdd = async (values) => {
    setSaving(true);
    try {
      await addReferralForUser({
        firestore,
        user: { uid: userId, firstName: userData.firstName, lastName: userData.lastName, phoneNumber: userData.phoneNumber },
        phone: values.phone,
        email: values.email,
      });
      message.success('Polecenie dodane');
      setModalOpen(false);
      form.resetFields();
      await load();
    } catch (e) {
      message.error('Błąd zapisu polecenia');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalOpen(true)} style={{ marginBottom: 16 }}>
        Dodaj polecenie
      </Button>

      {loading ? <Spin /> : (
        <List
          dataSource={referrals}
          locale={{ emptyText: 'Brak poleceń' }}
          renderItem={(r) => (
            <List.Item>
              <List.Item.Meta
                title={<>Tel: {r.phone || 'brak'} <Tag>{r.status || 'Oczekuje'}</Tag></>}
                description={`Email: ${r.email || 'brak'}`}
              />
            </List.Item>
          )}
        />
      )}

      <Modal title="Dodaj polecenie" open={modalOpen} onCancel={() => setModalOpen(false)} onOk={() => form.submit()} confirmLoading={saving} okText="Zapisz" cancelText="Anuluj">
        <Form form={form} layout="vertical" onFinish={handleAdd}>
          <Form.Item label="Numer telefonu" name="phone" rules={[{ required: true, message: 'Podaj numer telefonu' }, { pattern: /^[0-9]+$/, message: 'Tylko cyfry' }]}>
            <Input placeholder="np. 600100200" />
          </Form.Item>
          <Form.Item label="Adres e-mail" name="email" rules={[{ type: 'email', message: 'Niepoprawny e-mail' }]}>
            <Input placeholder="np. jan@example.com" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PoleceniaTab;
